<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
                <v-card title>
                    <v-card-title>
                        <h2>Distritos</h2>
                    </v-card-title>
                    <v-card-text>
                        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <DialogDistritos v-if="get_dialogMain.dialog" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DialogDistritos from '@/components/dialogs/DistritosDialog'
import DataTableMain from '@/components/tables/DataTableMain'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'distr.create' }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Tipo', value: 'tipo', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain,
    DialogDistritos
  },
  mounted () {
    this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
    this.getUrl('distr.get')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('distr.get')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getUrlServices', 'getUrlServicesAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServicesAction(router)
      } else {
        this.getUrlServices()
      }
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.table.header.options.map(action => {
            action.hidden = ''
          })
          this.table.body.actions.map(action => {
            action.hidden = ''
          })
        } else {
          this.table.header.options.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })

          this.table.body.actions.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.tableServer.header.options.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })

        this.tableServer.body.actions.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATAS_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('distr.get')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATAS_MAIN()
  }
}
</script>

<style>

</style>
